._ImagesEqual_1oyk6_1 {
  width: 100%;
}